import { useEffect } from "react";

const BASE_URL = "https://botsweep.com";

interface PageSEOOptions {
  title: string;
  path: string;
  noindex?: boolean;
  description?: string;
  ogType?: string;
}

function upsertMeta(name: string, content: string, attr: "name" | "property" = "name") {
  let el = document.querySelector(`meta[${attr}="${name}"]`) as HTMLMetaElement | null;
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, name);
    document.head.appendChild(el);
  }
  el.content = content;
  return el;
}

export function usePageSEO({ title, path, noindex = false, description, ogType }: PageSEOOptions) {
  useEffect(() => {
    document.title = title;

    // robots meta
    upsertMeta("robots", noindex ? "noindex, nofollow" : "index, follow");

    // canonical
    let canonical = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.rel = "canonical";
      document.head.appendChild(canonical);
    }
    if (noindex) {
      if (canonical.parentNode) canonical.parentNode.removeChild(canonical);
    } else {
      canonical.href = `${BASE_URL}${path}`;
    }

    // OG tags
    upsertMeta("og:title", title, "property");
    upsertMeta("og:url", `${BASE_URL}${path}`, "property");
    if (description) upsertMeta("og:description", description, "property");
    if (ogType) upsertMeta("og:type", ogType, "property");

    return () => {
      upsertMeta("robots", "index, follow");
    };
  }, [title, path, noindex, description, ogType]);
}
